import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=3d86d79b"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./AppFooter.vue?vue&type=style&index=0&id=3d86d79b&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "40a8dc8a"
  
)

export default component.exports